export default __webpack_public_path__ + "static/media/about-fig1.c19fe2b7.png";